module.exports = __webpack_public_path__ + "img/gray-btn.b67c21b7.svg";